// import React from 'react';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import RouterPage from './routes/RouterPage';

// function App() {
//   return (
//     <div className="App">
//       <RouterPage />
//     </div>
//   );
// }

// export default App;


import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css"; // 👈 Make sure this is imported
import RouterPage from "./routes/RouterPage";

function App() {
  return (
    <div className="App">
      <RouterPage />
    </div>
  );
}

export default App;
